/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import {
    array,
    bool, func, object, string,
} from 'prop-types';

import { Grid, makeStyles } from '@material-ui/core';

import ExactDay from '../ExactDay/ExactDay';
import ShipHolidaysList from '../ShipHolidaysList/ShipHolidaysList';

import {
    convertDateObjToStrDate,
    convertDateStringToObj, getDateStrBtn,
} from '../../helpers/Calendar-Helper';
import { calendarColorStyle } from '../../../Helpers/Style-Helper';
import { trackEvent } from '../../../../../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const useStyles = makeStyles(
    (theme) => ({
        root: {
            color: calendarColorStyle.primary?.main,
            padding: '8px 24px',
            borderBottom: `1px solid ${calendarColorStyle.primary?.[200]}`,
            [theme.breakpoints.down(490)]: {
                padding: '8px 16px',
            },
        },
    }),
    { name: 'EnterpriseCalendarHeader' },
);

const EnterpriseCalendarHeader = ({
    calendarData,
    calendarListByDates,
    forceExactDay,
    holidaySelected,
    selectedDeliveryDateObj,
    selectedDateRange,
    setForceExactDay,
    setHolidaySelected,
    setSelectedDateRange,
    setSelectedDeliveryDateObj,
    setStartDateCalendar,
    setSelectedHoliday,
    shipHolidayDetails,
    startDateCalendar,
}) => {
    const dispatchAction = useDispatch();
    const classes = useStyles();

    const isShowExactDay = (
        selectedDeliveryDateObj?.calendarDateType === 'between'
        && calendarData?.guaranteedCharge && calendarData?.guaranteedCharge !== 'null'
    );

    const handleForceExactDay = (event) => {
        const isChecked = event.target.checked;
        let selectedDateRangeInfo = selectedDateRange;
        if (isChecked && selectedDeliveryDateObj.calendarDateType === 'between') {
            selectedDateRangeInfo = [selectedDeliveryDateObj.deliveryDate];
        } else if (!isChecked && selectedDeliveryDateObj.calendarDateType === 'between') {
            const rangeStartDate = convertDateStringToObj(selectedDeliveryDateObj.rangeStartDate);
            const rangeEndDate = convertDateStringToObj(selectedDeliveryDateObj.deliveryDate);
            selectedDateRangeInfo = getDateStrBtn(rangeStartDate, rangeEndDate).map((date) => (
                convertDateObjToStrDate(date)
            ));
        }
        if (isChecked && Object.prototype.hasOwnProperty.call(calendarData, 'guaranteedCharge')) {
            setSelectedDeliveryDateObj({
                ...selectedDeliveryDateObj,
                guaranteedChargeToApply: calendarData.guaranteedCharge,
            });
        }

        setSelectedDateRange(selectedDateRangeInfo);
        setForceExactDay(isChecked);
        setHolidaySelected('Holiday Delivery');
        if (isChecked) {
            dispatchAction(
                trackEvent({
                    eventName: 'feature_interaction',
                    eventCategory: 'Checkout',
                    eventAction: 'Calendar',
                    eventLabel: 'Exact Day Delivery Checked',
                }),
            );
        }
    };

    const handleSelectHoliday = (selVal) => {
        setHolidaySelected(selVal);

        if (selVal !== 'Holiday Delivery') {
            const holidayDetails = shipHolidayDetails[selVal][0];
            let holidayDateStart = '';
            const tempholidayDate = holidayDetails.holidayDate.split(' ')[0];
            const arrholidayDate = tempholidayDate.split('-');
            holidayDateStart = `${arrholidayDate[0]}-${arrholidayDate[1]}-01`;

            setSelectedHoliday(holidayDetails);

            const selDateHoliday = convertDateStringToObj(tempholidayDate);
            // const selDateHolidayProps = calendarListByDates[selDateHoliday];
            setForceExactDay(false);
            setHolidaySelected(holidayDetails.holidayCode || 'Holiday Delivery');
            const calendarHolidayDetails = calendarListByDates?.[tempholidayDate]?.[0] || {};

            if (holidayDetails.holidayDate) {
                const holidayDeliveryDate = convertDateStringToObj(holidayDetails.holidayDate);
                let holidayStartDate = '';

                if (calendarHolidayDetails.holidayStartDate && calendarHolidayDetails.holidayStartDate !== tempholidayDate) {
                    holidayStartDate = convertDateStringToObj(calendarHolidayDetails.holidayStartDate);
                } else if (holidayDetails.holidayStartDate) {
                    holidayStartDate = convertDateStringToObj(holidayDetails.holidayStartDate);
                }
                if (holidayStartDate) {
                    const holidaySelectedDateRangeInfo = getDateStrBtn(holidayStartDate, holidayDeliveryDate).map((date) => (
                        convertDateObjToStrDate(date)
                    ));
                    setSelectedDateRange(holidaySelectedDateRangeInfo);
                }

                if (calendarHolidayDetails) {
                    setSelectedDeliveryDateObj(calendarHolidayDetails);
                }
            }
            setStartDateCalendar(holidayDateStart);
        } else {
            setSelectedHoliday({});
        }

        dispatchAction(
            trackEvent({
                eventName: 'feature_interaction',
                eventCategory: 'Checkout',
                eventAction: 'Calendar',
                eventLabel: 'Holiday Dropdown Selected',
            }),
        );
    };
    const showForceDelivery = (
        calendarData
        && selectedDeliveryDateObj?.calendarDateType === 'between'
        && calendarData.guaranteedCharge && calendarData.guaranteedCharge !== 'null'
    );

    if (['WO', 'MO'].includes(calendarData.deliveryIndicator)) {
        return null;
    }

    return (
        <Grid id="body-header" container className={classes.root}>
            <Grid item xs={12}>
                <Grid container className={`${(isShowExactDay || calendarData.shipHolidays?.length > 0)}`}>
                    <Grid item xs={7}>
                        <ExactDay
                            calendarDateType={selectedDeliveryDateObj.calendarDateType}
                            guaranteedCharge={calendarData.guaranteedCharge}
                            forceExactDay={forceExactDay}
                            handleForceExactDay={handleForceExactDay}
                        />
                    </Grid>
                    <Grid item xs={5}>
                        {
                            shipHolidayDetails
                            && Object.keys(shipHolidayDetails)?.length > 0
                            && (
                                <ShipHolidaysList
                                    shipHolidayDetails={shipHolidayDetails}
                                    holidaySelected={holidaySelected}
                                    handleSelectHoliday={handleSelectHoliday}
                                />
                            )
                        }
                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    );
};

EnterpriseCalendarHeader.propTypes = {
    calendarData: object.isRequired,
    calendarListByDates: object.isRequired,
    forceExactDay: bool.isRequired,
    holidaySelected: string.isRequired,
    selectedDeliveryDateObj: object.isRequired,
    selectedDateRange: array.isRequired,
    setForceExactDay: func.isRequired,
    setHolidaySelected: func.isRequired,
    setSelectedDateRange: func.isRequired,
    setSelectedDeliveryDateObj: func.isRequired,
    setStartDateCalendar: func.isRequired,
    setSelectedHoliday: func.isRequired,
    shipHolidayDetails: object,
    startDateCalendar: string.isRequired,
};

EnterpriseCalendarHeader.defaultProps = {
    shipHolidayDetails: {},
};

export default EnterpriseCalendarHeader;
